import React, { useState } from "react";
import { Configuration, OpenAIApi } from "openai";
import Loader from "react-js-loader";

export default function SocialMediaPost(props) {
    const [cname, setCname] = useState("");
    const [what, setWhat] = useState("");
    const [for_what, setForWhat] = useState("");
    const [textResult, setTextResult] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const OPENAI_API_KEY = "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";

    //using openAI
  const social_media_post = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "Generate a social media post for the company named " + cname +"which is in the "+what+". This post is to "+for_what,
      temperature: 0,
      max_tokens: 512,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });

    setTextResult(response.data.choices[0].text);
    setIsLoading(false)

    props.showAlert("Social Media Post Generated ", "success");
  };

  const handleOnChange_comp_name = (e) => {
    setCname(e.target.value);
  };

  const handleOnChange_for_what = (e) => {
    setForWhat(e.target.value);
  };

  const handleOnChange_what = (e) => {
    setWhat(e.target.value);
  };

  return (
    <div className={`text-${props.mode === "light" ? "dark" : "light"}`}>
      <p
        style={{
          marginTop: "10px",
          textAlign: "center",
          fontSize: "40px",
          fontFamily: "sans-serif",
          fontVariant: "small-caps",
          fontWeight: 600,
        }}
      >
        {" "}
        Social Media Post Generator
      </p>
      {isLoading ? (<>
        <div className="row"
             style={{
                      padding:"20px"
                    }}>
          <Loader type="bubble-loop" bgColor={"#5C0091"} size={150} /> 
        </div>
        </>
      ) : 
      (
      <>
      <div className="row">
        <div className="col-md-4 my-2">
            <textarea
            className="form-control"
            placeholder="Company Name"
            value={cname}
            id="company_name"
            rows="1"
            onChange={handleOnChange_comp_name}
            style={{
                backgroundColor: props.mode === "dark" ? "grey" : "white",
                color: props.mode === "dark" ? "white" : "black",
            }}
            ></textarea>
        </div>
        <div className="col-md-4 my-2">
            <textarea
            className="form-control"
            placeholder="Company Description"
            value={what}
            id="what_comp_do"
            rows="1"
            onChange={handleOnChange_what}
            style={{
                backgroundColor: props.mode === "dark" ? "grey" : "white",
                color: props.mode === "dark" ? "white" : "black",
            }}
            ></textarea>
        </div>
        <div className="col-md-4 my-2">
            <textarea
            className="form-control"
            placeholder="What is the post about?"
            value={for_what}
            id="for_what"
            rows="1"
            onChange={handleOnChange_for_what}
            style={{
                backgroundColor: props.mode === "dark" ? "grey" : "white",
                color: props.mode === "dark" ? "white" : "black",
            }}
            ></textarea>
        </div>
        </div>
        <div className="row">
            <div className="col-md-3 "></div>
            <div className="col-md-6 mx-2 my-2">
                <button
                    type="button"
                    className={`btn btn-${
                    props.mode === "dark" ? "dark" : "secondary"
                    } my-2 mx-2`}
                    onClick={social_media_post}
                    style={{ width: "100%", height: "100%" }}
                >
                    Generate Social Media Post
                </button>
            </div>
            <div className="col-md-1 "></div>
        </div>
        <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <p
            style={{
              fontSize: "30px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              fontWeight: 600,
              textAlign: "center",
              paddingTop: "15px",
            }}
          >
              {" "}
              {textResult.length === 0 ? "" : "Article:"}
          </p>
        </div>
        <div className="col-md-2">
        {textResult.length === 0 ? "" : 
        <>
          <button
            type="button"
            className={`btn btn-${
            props.mode === "dark" ? "dark" : "danger"
            } my-2 mx-2`}
            onClick={() => {
              navigator.clipboard.writeText(textResult);
              props.showAlert("Textbox Copied", "success");
            }}
            style={{ width: "100%", height: "100%" }}
          >
              Copy to Clipboard
          </button>
        </>
        }
        
        </div>
    </div>

    <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
            <p style={{
                textAlign:"justify"
              }}
            >
              {textResult}
            </p>   
        </div>
        <div className="col-md-2"></div>
    </div>
      </>
      )
      } 
    </div>
  );
};

